import React, { ChangeEventHandler, ReactNode, useEffect, useRef, useState } from "react";
import { Field, FieldMetaState } from "react-final-form";
import styles from './OutlinedFormInput.module.scss';
import CurrencyInput from 'react-currency-input-field';



type Props = {
  textFieldType?: 'filled' | 'outlined',
  label?: string,
  name: string,
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
  isTextArea?: boolean,
  error: any,
  touched: boolean,
  placeholder?: string
  value: string;
  maxLength?: number,
  unitPlaceHolder?: string,
  unitPosition?: "left" | "right",
  containerStyles?: React.CSSProperties,
  showError?: boolean;
  inpuType?: "text" | "number",
  onBlur?: (e: any) => void,
  onKeyDown?: (e: React.KeyboardEvent) => void,
  disabled?: boolean,
  buttonEle?: React.ReactNode,
  isCurrency?: boolean,
  showBorder?: boolean,
  showPlaceholder?: boolean,
  fieldType?: "md" | "lg",
  allUpercase?: boolean;
  showCheckbox?: boolean;
  checkboxOnChange?: (e: any) => void;
  checkboxValue?: boolean;
  checkboxLabel?: string;
  subText?: string;
  showErrorBorder?: boolean;
  allowDecimals?: boolean;
  maxRows?: number;
}



const OutlinedFormInput = ({ label, name, onChange: handleChange, isTextArea = false, error, touched, placeholder, value, maxLength, unitPosition = "left", inpuType = "text", unitPlaceHolder = null, containerStyles, showError = true, onBlur, onKeyDown = null, disabled = false, buttonEle, isCurrency, showBorder = false, showPlaceholder = true, fieldType = "md", allUpercase, showCheckbox = false, checkboxOnChange = () => { }, checkboxValue, checkboxLabel, subText = null, textFieldType = "outlined", showErrorBorder = false, allowDecimals = false, maxRows = 2, ...restProps }: Props) => {
  const inputRef = useRef(null);

  // console.log('name', name, 'unitPosition', unitPosition)

  // console.log('buttonEle', buttonEle)

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (inpuType === "number") {
      // Prevent 'e', 'E', '+', '-' from being entered
      if (['e', 'E', '+', '-', '='].includes(event.key)) {
        event.preventDefault();
      }
    }
  }




  return (
    <div className={`${styles.fieldContainer} ${styles[fieldType]}`}>
      {label && <div className={`${styles.label}`}>{label}</div>}
      <div className={`${styles.inputBoxRootContainer}  ${showCheckbox ? styles.showCheckbox : ''} ${showCheckbox && error && touched && (showError || showBorder) ? styles.invalid : ''}`}>
        <div className={`${styles.inputBox} ${styles[textFieldType]} ${unitPosition == "right" ? styles.reverse : ''} ${error && touched && textFieldType != "filled" && (showBorder || showError) ? styles.invalid : ''} ${disabled ? styles.disabled : ''} ${showErrorBorder ? styles.invalid : ''}`} style={containerStyles}>

          {unitPlaceHolder ? <div className={styles.unitPlaceholder}>
            {unitPlaceHolder}
          </div> : null}
          {isTextArea ?
            <textarea {...restProps} maxLength={maxLength} rows={maxRows} placeholder={placeholder ? placeholder : label ? `Enter ${label}` : ''} className={`${error && touched ? styles.invalid : ''}`} onChange={handleChange} value={value} />
            :
            isCurrency ? <CurrencyInput
              {...restProps}
              name={name}
              value={value}
              // decimalsLimit={2}
              prefix=""
              maxLength={maxLength}
              allowDecimals={allowDecimals}
              allowNegativeValue={false}
              intlConfig={{ locale: 'en-IN' }}
              onValueChange={(value, name, values) => {
                // console.log(value, name, values);
                handleChange({ target: { value: value } } as any);
              }}
              disabled={disabled}
              onBlur={onBlur}
              placeholder={placeholder ? placeholder : label && showPlaceholder ? `Enter ${label}` : ''}
            /> :
              <input
                ref={inputRef}
                {...restProps}
                name={name}
                style={{ textTransform: allUpercase ? "uppercase" : "initial" }}
                type={inpuType == "number" ? 'number' : inpuType}
                onKeyDown={onKeyDown ? onKeyDown : handleKeyDown}
                className={unitPosition == "right" ? styles.rightAlign : styles.leftAlign}
                disabled={disabled}
                onBlur={onBlur}
                // style={{ textAlign: unitPosition == "right" ? "right" : "left" }}
                // max={5}
                maxLength={maxLength}
                placeholder={placeholder ? placeholder : label && showPlaceholder ? `Enter ${label}` : ''}
                onChange={handleChange}
                value={value} />}

          {buttonEle ? <div className={styles.buttonContainer}>
            {buttonEle} </div> : null}


        </div>

        {showCheckbox ?
          <>
            <div className={styles.divider}></div>
            <div className={styles.checkBoxContainer}>
              <label style={{ cursor: "pointer" }} className={styles.checkboxField}>
                <input style={{ cursor: "pointer" }} type="checkbox" checked={checkboxValue} onChange={(e) => {
                  checkboxOnChange(e.target.checked);
                }} />
                <span>{checkboxLabel}</span>
              </label>
            </div>
          </>
          : null}
      </div>

      {error && touched && showError ? <span className={styles.errorMessage}>{error}</span> : subText ? <span className={styles.subText}> {subText}</span> : null}

    </div>
  );
}

// Utility function to format numbers with commas
// const formatNumberWithComma = (value: string) => {
//     // Your logic here, or reuse the provided function
//     return value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// };

export default OutlinedFormInput;